import { render, staticRenderFns } from "./FillForm5.vue?vue&type=template&id=5f23537c&scoped=true"
import script from "./FillForm5.vue?vue&type=script&lang=ts"
export * from "./FillForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23537c",
  null
  
)

export default component.exports